export default "__VITE_ASSET__CJhp4clU__"